// extracted by mini-css-extract-plugin
module.exports = {"content":"view-default_content_V041l","imageWrapper":"view-default_imageWrapper_iqlUO"};